module.exports = __webpack_public_path__ + "img/IMG_4215_L_WoodMatted_MockedUp.36b514be.jpg";